// extracted by mini-css-extract-plugin
module.exports = {"donutChart":"style_donutChart__2qOvB"};